"use strict";
var React = require("react");
var Router = require("react-router");
var Link = Router.Link;
var Alert = require("react-bootstrap").Alert;

var FourOFourErrorPage = React.createClass({
    render: function() {
        return (
            <div className="content_section">
                <div id="subheader">
                    <h1 className="subheader-title">404</h1>
                </div>
                <div className="errorpage-container container">
                    <Alert bsStyle="danger">
                        <h4>Hér er ekkert!</h4>
                        <p>Nema þessi texti til að láta þig vita að hér sé ekkert...</p>
                        <Link className="btn btn-success" to="/home" type="button" title="Back to home">
                            Fara aftur á forsíðu
                        </Link>
                    </Alert>
                </div>
            </div>
        );
    }
});

module.exports = FourOFourErrorPage;



// WEBPACK FOOTER //
// ./app/scripts/ui/ErrorPages/404ErrorPage.react.js